var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import { sizes } from './media';
export var GRID_UNIT = 8;
export var GUTTER = {
  mobile: 2 * GRID_UNIT,
  tablet: 4 * GRID_UNIT,
  desktop: 4 * GRID_UNIT
};
export var COLUMN_WIDTH = {
  mobile: 43.8,
  tablet: 68.2,
  desktop: 68.2
};
export var COLUMN_WIDTH_RELATIVE = 8.33;
/** @deprecated This should not be used anymore. */
export var gridWidth = Object.keys(sizes).reduce(function (interpolations, size) {
  var _a;
  return __assign(__assign({}, interpolations), (_a = {}, _a[size] = function (columnNum) {
    return COLUMN_WIDTH[size] * columnNum + GUTTER[size] * (columnNum - 1);
  }, _a));
}, {});